import { Injectable } from '@angular/core';

import { useDispatcher } from '../../../store.decorator';
import { updateCategoryAction } from '../dialog/state/update-category-action.action';

import { CategoryAction } from './category-action.model';
import { Category } from './category.model';
import { EventCentreHook } from './hook';
import { ItemAction } from './item-action.model';
import { Item } from './item.model';

@Injectable({ providedIn: 'root' })
export class EventCentreHookService {
    private readonly _hooks: EventCentreHook[];

    constructor() {
        this._hooks = [];
    }

    register(hook: EventCentreHook): void {
        if (!this._hooks.includes(hook)) {
            this._hooks.push(hook);
        }
    }

    unregister(hook: EventCentreHook): void {
        const index = this._hooks.indexOf(hook);
        if (index !== -1) {
            this._hooks.splice(index, 1);
        }
    }

    didOpen(atLogin: boolean, category: Category, ref: any): void {
        this._hooks.forEach((e) => {
            try {
                e.ecDidOpen?.(
                    atLogin,
                    category,
                    (modify, catAction, done): void => {
                        this._updateCategoryAction(
                            modify,
                            catAction,
                            done,
                            ref,
                        );
                    },
                );
            } catch (e) {
                console.log(e);
            }
        });
    }

    actionInvoked(item: Item, action: ItemAction): boolean {
        let dismiss = false;
        this._hooks.forEach((e) => {
            try {
                const ret = e.ecOnActionInvoked(item, action);
                dismiss = !dismiss && ret;
            } catch (e) {
                console.log(e);
            }
        });
        return dismiss;
    }

    actionInvoked2(
        item: Item,
        action: ItemAction,
        category: Category,
        ref: any,
    ): boolean {
        let dismiss = false;
        this._hooks.forEach((e) => {
            try {
                const ret = e.ecOnActionInvoked2?.(
                    item,
                    action,
                    category,
                    (modify, catAction, done): void => {
                        this._updateCategoryAction(
                            modify,
                            catAction,
                            done,
                            ref,
                        );
                    },
                );
                dismiss = !dismiss && ret;
            } catch (e) {
                console.log(e);
            }
        });
        return dismiss;
    }

    itemsChanged(items: Item[]): void {
        this._hooks.forEach((e) => {
            try {
                e.ecOnItemsChanged(items);
            } catch (e) {
                console.log(e);
            }
        });
    }

    categoryActionInvoked(
        category: Category,
        action: CategoryAction,
        items: Item[],
    ): void {
        this._hooks.forEach((e) => {
            try {
                e.ecOnCategoryActionInvoked?.(category, action, items);
            } catch (e) {
                console.log(e);
            }
        });
    }

    categoryActionInvoked2(
        category: Category,
        action: CategoryAction,
        items: Item[],
        ref: any,
    ): void {
        this._hooks.forEach((e) => {
            try {
                e.ecOnCategoryActionInvoked2?.(
                    category,
                    action,
                    items,
                    (modify, done): void => {
                        this._updateCategoryAction(modify, action, done, ref);
                    },
                );
            } catch (e) {
                console.log(e);
            }
        });
    }

    willClose(): void {
        this._hooks.forEach((e) => {
            try {
                e.ecWillClose?.();
            } catch (e) {
                console.log(e);
            }
        });
    }

    private _updateCategoryAction(
        modify: 'hidden' | 'disabled' | null,
        catAction: CategoryAction | null,
        done: Promise<void> | null,
        ref: any,
    ): void {
        if (catAction == null) {
            return;
        }
        useDispatcher(
            ref,
            updateCategoryAction({
                name: catAction.name,
                modify,
            }),
        );
        done?.finally(() => {
            useDispatcher(
                ref,
                updateCategoryAction({
                    name: catAction.name,
                    modify: null,
                }),
            );
        });
    }
}
